import { getCountry } from '@iwIntlProvider/CountryProvider';
import { IconFileEmptyFilled } from '@iwoca/icons';
import { FormattedMessage } from 'react-intl';

import styles from './DefaultView.module.css';
import { MainSectionWrapper } from '../../pageStructure/mainSectionWrapper';

const DefaultView = () => {
    return (
        <MainSectionWrapper className={styles.wrapper}>
            <div className={styles.card}>
                <div className={styles.iconContainer}>
                    <IconFileEmptyFilled className={styles.titleIcon} />
                </div>

                <div className={styles.title}>
                    <FormattedMessage
                        id="_.default_view.title"
                        defaultMessage="Looks like you have no new offers today."
                    />
                </div>

                <div className={styles.bodyText}>
                    <FormattedMessage
                        data-test-id="declined-body-text"
                        id="_.default_view.description"
                        defaultMessage="When you have a new approved offer, you can view it here in the 'My Offers' tab. If you think this is wrong, please call us on {phoneNumber}."
                        values={{
                            phoneNumber: (
                                <a
                                    href={
                                        getCountry() === 'DE'
                                            ? 'tel:069 9432 3020 '
                                            : 'tel:020 3778 0274'
                                    }
                                    className={styles.phoneNumber}
                                >
                                    <FormattedMessage
                                        tagName="strong"
                                        id="_.default_view.phoneNumber"
                                        defaultMessage="020 3778 0274"
                                    />
                                </a>
                            )
                        }}
                    />
                </div>
            </div>
        </MainSectionWrapper>
    );
};

// eslint-disable-next-line import/no-default-export
export default DefaultView;
